// extracted by mini-css-extract-plugin
module.exports = {"filter":"customer-filter_filter__2uaSA","status":"customer-filter_status__pigXB","search":"customer-filter_search__grawA","filterContent":"customer-filter_filterContent__1t2Ou"};